import { FC, ReactElement, useEffect, useRef, useState, useSyncExternalStore } from "react";
import { GoogleOAuthProvider, useGoogleLogin } from "@react-oauth/google";
import toast from "react-hot-toast";
import { fetchAsync, postAsync, postWithoutSign } from "../services/ApiHandler";
import { saveToken } from "../services/CookieHandler";
import { useDisclosure } from "@mantine/hooks";
import { Button, Center, Checkbox, Group, Modal, Radio } from "@mantine/core";
import { useHeaderStore } from "./CommonHeader";
import { RemainCountResponse } from "../model/RemainCountResponse";
import { Inspiration } from "../model/Inspiration";
import { ModelTaste } from "../model/ModelTaste";

export class InspirationDialogProps {
  inspiration?: Inspiration;
  mainTasteList?: ModelTaste[];
}

export const InspirationDialog: FC<InspirationDialogProps> = ({ inspiration, mainTasteList }) => {
  function setClipboard(text: string | undefined){
    navigator.clipboard.writeText(text ?? '');
    toast.success("クリップボードにコピーしました");
  }

  function openHintPage() {
    window.location.href = `/image-generation?inspiration-number=${inspiration?.inspirationNumber}`;
  }

  return <>
      <div className='text-start max-h-[80vh] overflow-scroll w-full sm:w-[1080px]' style={{ paddingTop: '0px' }}>
      <div className="block sm:flex">
        <div className="w-full sm:w-[60%] flex items-center sm:min-h-[500px] justify-center">
          <img className="max-w-[100%] max-h-[400px] sm:max-h-[600px]"  src={`${process.env.REACT_APP_IMAGE_URL}/sample/${inspiration?.imageFileName}`} />
        </div>
        <div className="w-full sm:w-[40%] sm:ml-4">
          <div className="text-sm mr-4 mt-4">プロンプト</div>
          <div className="text-sm border py-1 px-2 rounded flex justify-between bg-gray-100">
            { inspiration?.prompt }
            <img onClick={(e) => setClipboard(inspiration?.prompt)} src="/images/icon/icon-copy.svg" className="clickable w-[20px]"></img>
          </div>
          <>
          <div className="text-sm mt-4">ネガティブプロンプト</div>
          <div className="text-sm border py-1 px-2 min-h-7 rounded flex justify-between bg-gray-100">
          { inspiration?.negativePrompt }
          <img onClick={(e) => setClipboard(inspiration?.negativePrompt)} src="/images/icon/icon-copy.svg" className="clickable w-[20px]"></img>
          </div>
          <div className="text-sm mt-4">モデル</div>
          <div className="text-sm py-1">
            { mainTasteList?.filter((e) => e.modelName === inspiration?.modelTaste)[0].name }
          </div>
          </>
          <div className="mt-4">
            <button onClick={openHintPage} className="gradation-button w-full py-2">このプロンプトを利用する</button>
          </div>
        </div>
      </div>
    </div>
  </>;
}
